/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends, objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';

var _excluded = ["render", "headers", "initialSize", "initialCols"];

/* eslint-disable react/prop-types */

/*
 * Higer Order Component that wraps DataTable,
 * returning a new coWrappedDataTable settings support
 */
var withSettings = function withSettings(WrappedDataTable) {
  return function (_ref) {
    var render = _ref.render,
      headers = _ref.headers,
      initialSize = _ref.initialSize,
      initialCols = _ref.initialCols,
      passthroughProps = _objectWithoutProperties(_ref, _excluded);
    var _useState = useState(initialSize),
      _useState2 = _slicedToArray(_useState, 2),
      selectedSize = _useState2[0],
      setSelectedSize = _useState2[1];
    var _useState3 = useState(initialCols),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedCols = _useState4[0],
      setSelectedCols = _useState4[1];
    var augmentedRender = function augmentedRender(renderProps) {
      var augmentedRenderProps = _objectSpread2(_objectSpread2({}, renderProps), {}, {
        size: selectedSize,
        onSizeChange: function onSizeChange(value) {
          return setSelectedSize(value);
        },
        cols: selectedCols,
        onColumnsChange: function onColumnsChange(value) {
          return setSelectedCols(_toConsumableArray(value));
        },
        onReset: function onReset(value) {
          if (value && value.defaultSize) {
            setSelectedSize(value.defaultSize);
          }
          if (value && value.defaultCols) {
            setSelectedCols(_toConsumableArray(value.defaultCols));
          }
        }
      });
      return render(augmentedRenderProps);
    };

    // selectedCols may not exist as initialCols is an optional prop
    var selectedHeaders = headers.filter(function (h) {
      return !selectedCols || selectedCols.includes(h.key);
    });
    return /*#__PURE__*/React.createElement(WrappedDataTable
    // eslint-disable-next-line react/jsx-props-no-spreading
    , _extends({}, passthroughProps, {
      render: augmentedRender,
      size: selectedSize,
      headers: selectedHeaders
    }));
  };
};
var withSettings$1 = withSettings;

export { withSettings$1 as default };
